import classnames from 'clsx';
import {usePdfViewerDispatch, usePdfViewerState} from '../hooks';
import {ThumbnailItem} from '../thumbnail-item';
import React from 'react';
import {IoIosArrowForward} from 'react-icons/io';
import {animated, useSpring} from 'react-spring';
import ReactTooltip from 'react-tooltip';

import styles from './sidebar.module.scss';

export const Sidebar = () => {
  const {isSideBarVisible: show, toggleShowSidebar: onToggleShow, elements, elementSelected} = usePdfViewerState();
  const dispatch = usePdfViewerDispatch();

  const expand = useSpring({
    width: show ? '260px' : '0',
  });

  const content = useSpring({
    opacity: show ? 1 : 0,
  });

  const spin = useSpring({
    config: {friction: 10},
    transform: show ? 'rotate(180deg)' : 'rotate(0deg)'
  });

  return (
    <>
      <ReactTooltip
        id="collapseTooltip"
        type="info"
        effect="solid"
        textColor="var(--primary)"
        border
        borderColor="var(--primary)"
        backgroundColor="white">
        {!show ? 'Expandir' : 'Contraer'}
      </ReactTooltip>

      <animated.div className={styles.container} style={expand}>
        <animated.button
          data-tip data-for="collapseTooltip"
          className={styles.actionButton}
          onClick={onToggleShow}
          style={spin}>
          <IoIosArrowForward/>
        </animated.button>

        <animated.div
          className={classnames('flex flex-col overflow-y-auto overflow-x-hidden h-full scrollbar-hide absolute top-0 left-0 w-full pt-8 pr-6 pl-3 pb-4 gap-y-4')}
          style={content}>
          {
            elements.map(element => {
              return (
                <ThumbnailItem
                  key={element.id}
                  element={element}
                  isSelected={elementSelected?.id === element.id}
                  onSelected={doc => {
                    dispatch({
                      type: 'SELECT_ELEMENT_ACTION',
                      payload: doc
                    });
                  }}/>
              );
            })
          }
        </animated.div>
      </animated.div>
    </>
  );
};
